import React from 'react'

const Loader = () => (
  <div className="loader">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65 65">
      <defs>
        <filter id="Rectangle_1562" width="65" height="65" x="0" y="0" filterUnits="userSpaceOnUse">
          <feOffset />
          <feGaussianBlur result="blur" stdDeviation="5" />
          <feFlood floodOpacity=".302" />
          <feComposite in2="blur" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="spinner" transform="translate(-155.782 -559.609)">
        <g className="cls-3" transform="translate(155.78 559.61)">
          <rect
            id="Rectangle_1562-2"
            fill="#fff"
            width="35"
            height="35"
            className="cls-1"
            data-name="Rectangle 1562"
            rx="17.5"
            transform="translate(15 15)"
          />
        </g>
        <path
          id="Path_3"
          d="M19.3 3a12.31 12.31 0 0 1 5.3 15.3 12.671 12.671 0 0 1-6 6.5 13.007 13.007 0 0 1-8.9 1 12.7 12.7 0 0 1-7.4-5.2 13.245 13.245 0 0 1-2.2-8.9 13.575 13.575 0 0 1 4.2-8.3A14.177 14.177 0 0 1 13.1 0a1.451 1.451 0 0 1 .1 2.9h-.1a10.554 10.554 0 0 0-7 2.5A10.478 10.478 0 0 0 2.4 12 10.46 10.46 0 0 0 4 19.5a11.668 11.668 0 0 0 6.2 4.7 10.827 10.827 0 0 0 7.9-.6 11.7 11.7 0 0 0 5.7-5.7 11.9 11.9 0 0 0 .5-8.1 11.584 11.584 0 0 0-5-6.5c-.1 0-.1-.1-.1-.2-.1-.1 0-.2.1-.1z"
          className="cls-2"
          data-name="Path 3"
          transform="translate(174.967 579)"
        />
      </g>
    </svg>
  </div>
)

export default Loader
